export const REDIRECT = "REDIRECT";
export const CLEAR_REDIRECT = "CLEAR_REDIRECT";

export function redirect(path) {
    return {
        type: REDIRECT,
        path
    };
}

export function clearRedirect() {
    return {
        type: CLEAR_REDIRECT
    };
}
